import React, { useCallback } from 'react'
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";

const containerStyle = {
	width: "100%",
	height: "520px",
	maxHeight: "520px",
};

const center = { lat: -33.84975, lng: -70.6584 };

function Map() {
	const { isLoaded, loadError } = useJsApiLoader({
		id: 'google-map-script',
		googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyCfVfRoFZR_G-c7XWAT2pXlYwsr9rjPQbE",
		version: "3.53", // Versión estable compatible con Node 14
		libraries: [], // Sin librerías adicionales para evitar conflictos
		preventGoogleFontsLoading: true, // Mejora el rendimiento
		loadingElement: <div style={{ height: "100%" }} />
	});

	const onLoad = useCallback((map) => {
		// Opcional: puedes hacer algo cuando el mapa se carga
		console.log('Mapa cargado correctamente');
	}, []);

	const onUnmount = useCallback((map) => {
		// Limpiar referencias cuando el componente se desmonta
	}, []);

	if (loadError) {
		return <div>Error al cargar el mapa</div>;
	}

	if (!isLoaded) {
		return <div>Cargando mapa...</div>;
	}

	return (
		<GoogleMap
			mapContainerStyle={containerStyle}
			center={center}
			zoom={12}
			mapTypeId={"hybrid"}
			onLoad={onLoad}
			onUnmount={onUnmount}
			options={{
				// Opciones adicionales para mejorar rendimiento
				zoomControl: true,
				streetViewControl: false,
				mapTypeControl: true,
				fullscreenControl: true,
			}}
		>
			<Marker 
				position={center}
				title="San Isidro Paine"
				// Quitamos la animación para evitar advertencias en Node 14
				// animation={window.google?.maps?.Animation?.DROP}
			/>
		</GoogleMap>
	);
}

export default Map